import { useContext, useEffect, useState } from 'react'
import OtpInput from 'react18-input-otp';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { loginApi } from '../../services/services'
import { toast } from 'react-toastify'
import axios from 'axios'
import jwtDecode from 'jwt-decode'

import { LoginContext } from './../../context/LoginContext'
import useAuth from './../../hooks/useAuth'

export default function OTP(number) {
  const [code, setCode] = useState('')
  const [sec, setSec] = useState(120)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/'

  const { phonenumber, setLoginForm, setotp } = useContext(LoginContext)
  const { setAuth } = useAuth()

  useEffect(() => {
    const timer = sec > 0 && setInterval(() => setSec(sec - 1), 1000)
    return () => clearInterval(timer)
  }, [sec])

  const handleChange = code => {
    var e = document.getElementById('sb_b')
    setCode(code)
    if (code.length === 6) {
      e.classList.remove('disabled')
      sendCodeToDB(code)
    } else {
      e.classList.add('disabled')
    }
  }

  //send code to server
  const sendCodeToDB = async code => {
    const getApiLogin = loginApi(phonenumber, code)

    try {
      setLoading(true)
      const response = await axios.post(
        getApiLogin.SERVER_URL,
        getApiLogin.body,
        { withCredentials: true }
      )

      // console.log(response?.data)

      const accessToken = response?.data?.access_token
      const refreshToken = response?.data?.refresh_token
      const readToken = jwtDecode(accessToken)
      const role = Array.isArray(readToken.role) ? readToken.role : [readToken.role]
      const user = readToken.preferred_username

      const Arr = {
        a: accessToken,
        r: refreshToken
      }
      // localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('user', JSON.stringify(Arr))
      // localStorage.setItem('r', refreshToken)

      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

      setAuth({ user, role, accessToken, refreshToken })

      navigate(from, { replace: true })
      //
    } catch (err) {
      toast.error('کد وارد شده معتبر نمیباشد!')
    } finally {
      setLoading(false)
    }
  }

  //Resend code to server
  const reSendCodeToDB = code => {
    const getApiLogin = loginApi(phonenumber, '')
    axios
      .post(getApiLogin.SERVER_URL, getApiLogin.body, getApiLogin.config)
      .catch(function (error) { })
  }

  //submitClicked
  const submitClickedOTP = () => {
    sendCodeToDB(code)
  }
  //editPhoneNumber
  const editPhoneNumber = event => {
    setotp(false)
    setLoginForm(true)
  }
  //sendCodeAgain
  const sendCodeAgain = event => {
    setSec(200)
    setCode()
    reSendCodeToDB()
  }

  return (
    <>
      <p style={{ fontSize: '13px', marginBottom: '0' }}>
        کد 6 رقمی به شماره {phonenumber} ارسال شد، کد را اینجا وارد کنید.
      </p>
      <div id='codeBox' className='loginBox'>
        <OtpInput
          value={code}
          onChange={handleChange}
          numInputs={6}
          separator={<span style={{ width: '10px' }}></span>}
          isInputNum={true}
          shouldAutoFocus={true}
          inputStyle={{
            border: 'none',
            borderBottom: '1px solid #999',
            borderRadius: 0,
            width: '55px',
            height: '55px',
            fontSize: '18px',
            color: '#000',
            fontWeight: '400',
            caretColor: 'black'
          }}
          focusStyle={{
            borderBottom: '1px solid #000',
            outline: 'none'
          }}
        />
      </div>
      <p>
        {loading ? (
          <input
            className='disabled'
            type='submit'
            value='لطفا صبر کنید...'
          />
        ) : (
          <input
            id='sb_b'
            className='disabled'
            type='submit'
            value='ورود/ثبت نام'
            onClick={submitClickedOTP}
          />
        )}
      </p>
      <p className='tinyp'>
        {sec > 0 ? (
          `${sec} ثانیه تا درخواست مجدد کد`
        ) : (
          <Link onClick={sendCodeAgain}>درخواست ارسال دوباره کد</Link>
        )}
      </p>
      <p className='tinyp'>
        <Link onClick={editPhoneNumber}>اصلاح شماره موبایل</Link>
      </p>
    </>
  )
}
